import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {IDialogComponent} from '../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../common/dialog/dialogWithInput';
import {PlatformControl} from "../../../../controls/core/platform/platform.control";


export interface PdfPreviewModalInput {
  pdfBlob?: any;
  imageBlob?: any;
  fileName: string;
  displayDownloadButton?: boolean;
  displayPrintButton?: boolean;
}
@Component({
  templateUrl: './pdf-preview-modal.component.html',
})
export class PdfPreviewModalComponent implements OnInit, IDialogComponent<PdfPreviewModalInput, void> {

  dialog: DialogWithInput<PdfPreviewModalInput, void>;

  pdfBlob;
  imageBlob;
  fileName: string;

  objectUrl: string;
  safeUrl: SafeUrl;

  constructor(private sanitizer: DomSanitizer,
              private platformControl: PlatformControl) { }

  ngOnInit() {
    if (this.dialog) {
      this.pdfBlob = this.dialog.input.pdfBlob;
      this.imageBlob = this.dialog.input.imageBlob;
      this.fileName = this.dialog.input.fileName;
    }
    this.objectUrl = (window.webkitURL || window.URL).createObjectURL(this.pdfBlob ? this.pdfBlob : this.imageBlob);
    this.safeUrl = this.sanitizer.bypassSecurityTrustUrl(this.objectUrl);
  }

  download(){
    const anchor = document.createElement('a');
    anchor.download = this.fileName;
    anchor.href = this.objectUrl;
    anchor.click();
  }

  print() {
    if (this.platformControl.isFirefox()) {
      const printWindow = window.open(this.objectUrl);
      printWindow.onload = function() {
        printWindow.print();
      };
    } else {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = this.objectUrl;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    }
  }
}
